// extracted by mini-css-extract-plugin
export default {"container":"OnMapInfoWindow_container__Dj-Dj"};